import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=3b45bf66&scoped=true"
import script from "./Notes.vue?vue&type=script&lang=ts"
export * from "./Notes.vue?vue&type=script&lang=ts"
import style0 from "./Notes.vue?vue&type=style&index=0&id=3b45bf66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b45bf66",
  null
  
)

export default component.exports